import angular from 'angular';
import gridHeight from '../../core/shared-service/grid-utils';

(function() {
  'use strict';

  var orderDetail = {
    templateUrl: require('./order-detail.html'),
    bindings: {
      order: '<' // Commande
    },
    controller: OrderDetailController
  };

  OrderDetailController.$inject = ['uiGridConstants'];

  function OrderDetailController(uiGridConstants) {
    var vm = this;
    vm.getGridHeight = getGridHeight;

    var statusCellTemplate =
      '<div class="ui-grid-cell-contents" translate>{{ \'kiss_order.status.\' + (row.entity.status !== null && row.entity.status !== undefined  ? row.entity.status : grid.appScope.$ctrl.order.status | lowercase)}}</div>';

    vm.gridOptions = {
      columnDefs: [
        {
          name: 'status',
          displayName: 'commons.status',
          headerCellFilter: 'translate',
          cellTemplate: statusCellTemplate,
          cellClass: function(grid, row) {
            return row.entity.getStatusColor() + ' status';
          }
        },
        {
          name: 'sellerProductIdentifier',
          displayName: 'kiss_order.poste',
          headerCellFilter: 'translate',
          sort: { direction: 'asc', priority: 0 }
        },
        { name: 'note', displayName: 'kiss_order.note', headerCellFilter: 'translate' },
        {
          name: 'quantity',
          displayName: 'kiss_order.ordered_quantity',
          headerCellFilter: 'translate',
          cellFilter: 'number:2',
          cellClass: 'cell-number'
        },
        {
          name: 'billedQuantity',
          displayName: 'kiss_order.billed_quantity',
          headerCellFilter: 'translate',
          cellFilter: 'number:2',
          cellClass: 'cell-number'
        },
        {
          name: 'unitPrice',
          displayName: 'kiss_order.unit_price_excluding_taxes',
          headerCellFilter: 'translate',
          cellFilter: 'number:2',
          cellClass: 'cell-number'
        },
        {
          name: 'exclusiveTaxAmountLine',
          displayName: 'kiss_order.exclusive_tax_amount_line',
          headerCellFilter: 'translate',
          cellFilter: 'number:2',
          cellClass: 'cell-number'
        }
      ],
      exporterOlderExcelCompatibility: true,
      enableSorting: true,
      onRegisterApi: onRegisterApi,
      enableGridMenu: false,
      enableColumnMenus: false,
      enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
      paginationPageSizes: [20, 50, 100],
      paginationPageSize: 20
    };

    vm.$onChanges = function(changesObj) {
      if (changesObj.order && changesObj.order.currentValue) {
        vm.order = changesObj.order.currentValue;
        if (vm.order.type === 'FULL') {
          vm.gridOptions.columnDefs[4].visible = false;
          vm.gridOptions.columnDefs[7].visible = false;
        }
        vm.gridOptions.data = vm.order.lines;
        vm.gridOptions.totalItems = vm.order.lines.length;
      }
    };

    // Grille
    function onRegisterApi(gridApi) {
      vm.gridApi = gridApi;
    }

    function getGridHeight() {
      gridHeight(vm.gridApi);
    }
  }

  angular.module('app.kissorder').component('orderDetail', orderDetail);
})();
